import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  packagesTitle: {
    defaultMessage: 'Packages',
    description: 'Header for the center panel showing package cards',
    id: 'XD4oUY',
  },
  packagesInstruction: {
    defaultMessage: 'Add packages and drag order items here to assign them.',
    description: 'Instruction text explaining how to add and assign packages',
    id: 'SbvS00',
  },
  addPackage: {
    defaultMessage: 'Add Package',
    description: 'Button text to add a single package',
    id: 'Y2j2Pm',
  },
  addPackagesLabel: {
    defaultMessage: 'Add {numberOfPackages} Packages',
    description: 'Dropdown menu option to add multiple packages at once. {numberOfPackages} is a number like 5, 10, or 15',
    id: 'BgH+87',
  },
});
